//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "ServiceRequestAlerts.vue",

    props: {
        propertyId: {
            required: true,
            type: Number
        }
    },

    data: function data() {
        return {
            requests: [],
            headers: ['Name', 'Unit', 'Category', 'Date Submitted', 'Status'],
            fields: ['name', 'unit', 'category', 'created_at', 'status']
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.getServiceRequests();

        Event.$on('view-service-request', function (item, idx) {
            Event.$emit('view-service', item.id);
        });

        Event.$on('refresh-service-requests', function () {
            _this.getServiceRequests();
        });
    },


    methods: {
        getServiceRequests: function getServiceRequests() {
            var _this2 = this;

            axios.get('/prototype/property/' + this.propertyId + '/resident-service-requests').then(function (res) {
                _this2.requests = res.data;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/dashboard/ServiceRequests.vue
// module id = 5xnC
// module chunks = 0 1